import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	navigationListLabel: {
		id: 'accessible-workflow-diagram.list-navigation.navigation-list-label',
		defaultMessage: 'Navigate statuses and transitions in the workflow.',
		description:
			'Label for navigation list which allows keyboard users to navigation statuses and transitions in the workflow',
	},
	navigationListDescription: {
		id: 'accessible-workflow-diagram.list-navigation.navigation-list-description',
		defaultMessage:
			'Use direction keys to pan diagram. Use plus and minus keys to zoom the diagram.',
		description:
			'Description for navigation list which allows keyboard users to navigation statuses and transitions in the workflow',
	},
	initialTransitionListLabel: {
		id: 'accessible-workflow-diagram.list-navigation.initial-transition-list-label',
		defaultMessage: 'First transition.',
		description: 'Label for nested list under start node which contains the initial transition.',
	},
	statusTransitionsListLabel: {
		id: 'accessible-workflow-diagram.list-navigation.status-transitions-list-label',
		defaultMessage: 'Transitions for {statusName}.',
		description: 'Label for nested list under status which contains transitions for that status.',
	},
	startNodeMoveStartAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.start-node-move-start-announcement',
		defaultMessage:
			'Moving start node. Current position x: {x} y: {y}. Change position with arrow keys. Hold “shift“ to make greater movements or “alt“ to make finer movements. Confirm with “enter“ or cancel with “escape“.',
		description:
			'Announcement provided for screen readers when a move of the start node is initiated.',
	},
	statusMoveStartAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.status-move-start-announcement',
		defaultMessage:
			'Moving {statusName} status. Current position x: {x} y: {y}. Change position with arrow keys. Hold “shift“ to make greater movements or “alt“ to make finer movements. Confirm with “enter“ or cancel with “escape“.',
		description: 'Announcement provided for screen readers when a move of a status is initiated.',
	},
	globalLoopsContainerMoveStartAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.global-looped-transitions-container-move-start-announcement',
		defaultMessage:
			'Moving global looped transitions container. Current position x: {x} y: {y}. Change position with arrow keys. Hold “shift“ to make greater movements or “alt“ to make finer movements. Confirm with “enter“ or cancel with “escape“.',
		description:
			'Announcement provided for screen readers when a move of a global looped transitions container is initiated.',
	},
	moveUpdateAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.move-update-announcement',
		defaultMessage: 'x: {x}, y: {y}',
		description:
			'Announcement provided for screen readers when the position of a moving item is changed.',
	},
	moveCompleteAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.move-complete-announcement',
		defaultMessage: 'Move completed. New position x: {x} y: {y}',
		description: 'Announcement provided for screen readers when moving an item is completed.',
	},
	moveCancelAnnouncement: {
		id: 'accessible-workflow-diagram.list-navigation.move-cancel-announcement',
		defaultMessage: 'Move canceled.',
		description: 'Announcement provided for screen readers when moving an item is canceled.',
	},

	editHelpText: {
		id: 'accessible-workflow-diagram.list-navigation.edit-help-text',
		defaultMessage: 'Select to edit details.',
		description: 'Help text provided for screen readers for editing diagram items.',
	},
	moveHelpText: {
		id: 'accessible-workflow-diagram.list-navigation.move-help-text',
		defaultMessage: 'Press “m” to enter move mode.',
		description: 'Help text provided for screen readers for moving diagram items.',
	},
	deleteHelpText: {
		id: 'accessible-workflow-diagram.list-navigation.delete-help-text',
		defaultMessage: 'Select and press “delete” to delete.',
		description: 'Help text provided for screen readers for deleting diagram items.',
	},
	globalLoopedTransitionsList: {
		id: 'accessible-workflow-diagram.list-navigation.global-looped-transitions-list',
		defaultMessage: 'Global looped transitions',
		description: 'Label for nested list of global looped transitions in the workflow.',
	},
	containerLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-container.container-label',
		defaultMessage: 'Global looped transition container',
		description: 'Label for the global looped transition container',
	},
});
